import React from "react";
import Image from "next/image";
import { RestrictedGroupProps } from "@/types/ui-kit/ui";

export const RestrictedGroup: React.FC<RestrictedGroupProps> = ({ title, allowed, children }) => {
  return (
    <>
      {allowed ? (
        children
      ) : (
        <div className="-mx-3 mb-3 rounded-sm bg-gray-100 dark:bg-white-25">
          <div className="flex border-b border-gray-200 px-3 pb-2 pt-3 dark:border-white-25">
            <Image
              src="/assets/images/icons/lock.svg"
              width={16}
              height={16}
              className="mb-1 mr-1 dark:invert"
              alt="Reporter"
            />
            <span className="font-condensed text-2xs font-normal text-dark dark:text-white">{title}</span>
          </div>
          <div className={`pointer-events-none px-3 pt-3 ${allowed ? "" : "opacity-50"}`}>{children}</div>
        </div>
      )}
    </>
  );
};
